import { createContext, useContext, useState, useEffect } from 'react';
import { getCsrfToken, login as apiLogin, getMe, logout as apiLogout } from '@/lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [admin, setAdmin] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    if (!getCsrfToken()) {
      setLoading(false);
      return () => { active = false; };
    }
    getMe().then((res) => {
      if (active) setAdmin(res.data);
    }).catch(() => {
      if (active) setAdmin(null);
    }).finally(() => {
      if (active) setLoading(false);
    });
    return () => { active = false; };
  }, []);

  const login = async (email, password) => {
    const res = await apiLogin(email, password);
    setAdmin(res.data);
    return res.data;
  };

  const logout = async () => {
    try { await apiLogout(); } catch { /* Clear local UI state even if a session already expired. */ }
    setAdmin(null);
  };

  return (
    <AuthContext.Provider value={{ admin, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
